import { Routes, Route } from "react-router-dom";
import StudentJoin from "./pages/StudentJoin";
import ComingSoon from "./pages/ComingSoon";
import StudentHunt from "./pages/StudentHunt";
import TeacherSignIn from "./pages/TeacherSignIn";
import TeacherDashboard from "./pages/TeacherDashboard";
import TeacherCreate from "./pages/TeacherCreate";
import TeacherReview from "./pages/TeacherReview";

export default function App() {
  return (
    <Routes>
      {/* EDU is not runnable in production yet (anonymous auth off): the
          landing is a coming-soon page with the launch interest form (Dena,
          Oct 8, 2026). The join form stays reachable at /join for testing and
          for the day classes open; swap the two routes then. */}
      <Route path="/" element={<ComingSoon />} />
      <Route path="/join" element={<StudentJoin />} />
      <Route path="/play/:classId" element={<StudentHunt />} />
      <Route path="/teacher" element={<TeacherSignIn />} />
      <Route path="/teacher/dashboard" element={<TeacherDashboard />} />
      <Route path="/teacher/create" element={<TeacherCreate />} />
      <Route path="/teacher/hunt/:huntId" element={<TeacherReview />} />
    </Routes>
  );
}
